import React, { useRef, useContext, useLayoutEffect } from 'react'
import { statusContext } from './config'

const Checkbox = (props) => {

  const status = useContext(statusContext)

  const { indeterminate, checked, id, compute, items, filterType, setActiveFilter, ...rest } = props;
  const inputRef = useRef(null);

  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
      inputRef.current.checked = checked;
    }
  }, [indeterminate, checked]);

  const filterCount = (id.indexOf('select_all') !== -1) ? 'all' : (items && items.length) ? 'some' : 'one'

  return (
    <input
      {...rest}
      id={id}
      ref={inputRef}
      type="checkbox"
      onChange={() => {
        setActiveFilter(id, inputRef.current.checked, filterType, filterCount, items)
        const newStatus = inputRef.current.checked
        ? status.checked
        : status.unchecked
        if (id === 'road_closures') {
          props.setClosureActive(false)
        }
        compute(id, newStatus)
      }}
    />
  );
}

export default Checkbox
